/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgPinIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.501 20.5L20.501 10.5C20.9683 10.0421 21.3401 9.49606 21.5951 8.89352C21.85 8.29099 21.983 7.64389 21.9863 6.98965C21.9896 6.33541 21.8632 5.687 21.6143 5.08192C21.3655 4.47684 20.9991 3.92709 20.5365 3.46447C20.0739 3.00184 19.5241 2.63552 18.9191 2.38668C18.314 2.13783 17.6656 2.01141 17.0113 2.01471C16.3571 2.01802 15.71 2.15098 15.1075 2.40593C14.5049 2.66087 13.9589 3.03273 13.501 3.5L3.50098 13.5C3.03371 13.9579 2.66185 14.5039 2.4069 15.1065C2.15196 15.709 2.01899 16.3561 2.01569 17.0104C2.01238 17.6646 2.13881 18.313 2.38765 18.9181C2.6365 19.5232 3.00282 20.0729 3.46545 20.5355C3.92807 20.9982 4.47782 21.3645 5.0829 21.6133C5.68798 21.8622 6.33638 21.9886 6.99063 21.9853C7.64487 21.982 8.29197 21.849 8.8945 21.5941C9.49703 21.3391 10.0431 20.9673 10.501 20.5Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.5 8.5L15.5 15.5" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default SvgPinIcon;
